import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCounter } from '../../hooks/notes/use_counter';
import { styled } from '../../styles';
import { Row } from '../layout/flex';
import AppText from '../typography/app_text';
export function Counter() {
    const { count, color, maxCharacters, semibold } = useCounter();
    return (_jsx(CounterRow, { children: _jsxs(AppText, { color: color, semibold: semibold, "data-testid": "notes-counter-text", children: [count, "/", maxCharacters] }) }));
}
const CounterRow = styled(Row)({
    justifyContent: 'flex-end',
    width: '100%',
    height: '1.5rem',
    paddingRight: '1.5rem',
});
//# sourceMappingURL=counter.js.map